import Lottie from 'lottie-react'
import React from 'react'
import loaderAnimation from '../assets/loader-animation.json';

const GameLoading = () => {
    return (
        <div className="bg-gray-900 text-white font-semibold w-full h-full bg-opacity-80 flex flex-col items-center justify-center gap-4 z-50 backdrop-blur-sm" style={{ pointerEvents: 'all' }}>
            <Lottie animationData={loaderAnimation} loop={true} className="w-20 h-20" />
            Please Wait, We are loading the game...
        </div>
    )
}

export default GameLoading
